import { isToday, format, parseISO } from 'date-fns';

export const dndUntilShortDisplay = (dateTime) => {
  try {
    if (!dateTime || dateTime === "0001-01-01T00:00:00Z") return "I change my status";
    const date = isNaN(Array.from(dateTime)[0]) ? dateTime : parseISO(dateTime);
    if (isToday(date)) return `${format(date, 'h:mm aaa')}`;
    return `${format(date, 'Pp')}`;
  } catch (error) {
    console.error('There was an error while processing the date:', error);
    return '';
  }
};